import React from 'react';
import classNames from 'classnames';
import { render } from 'react-dom';

export const STATES = {
  UnChecked: 0,
  Checked: 1,
  Other: 2
}

export default ({state, text, onChecked, disabled = false, type = 'normal', innerStyle = 'red',
                  textMode = 'div', border = false, colorClass = "color-light", classNamesList = ""}) => {
  if (type === 'normal') {
    let _text = null;
    if (text) {
      switch (textMode) {
        case "div":
           if (border) {
            _text = (!disabled && state == STATES.UnChecked)
              ? <div
                 className={"lightbox-enable-container lightbox-disabled ui-svg-checkbox__text " + colorClass}>{text}</div>
              : <div className="lightbox-enable-container lightbox-enabled ui-svg-checkbox__text">{text}</div>;
          } else {
            _text = (!disabled && state == STATES.UnChecked)
              ? <div className={"ui-svg-checkbox__text " + colorClass}>{text}</div>
              : <div className="ui-svg-checkbox__text">{text}</div>;
          }
          break;
        case "h1":
          _text = <h1>{text}</h1>;
          break;
      }
    }




    return (
      <div className={classNames('ui-svg-checkbox', ...classNamesList, {'ui-svg-checkbox--disabled': disabled})}
           onClick={(e) => !disabled && onChecked(state, e)}>
        <div className="ui-svg-checkbox__icon">
          <svg className="ui-svg-checkbox__icon-circle" height="30" width="30">
            <circle cx="15" cy="15" r="12.5" stroke="#979797" strokeWidth="3" fill="#ffffff"/>
            {disabled ? <circle cx="15" cy="15" r="6" stroke="#c6c6c6" strokeWidth="3" fill="#c6c6c6"/> : null}
          </svg>

          <div className={classNames({
            "ui-svg-checkbox__icon-checked-icon": state == STATES.Checked,
            "ui-svg-checkbox__icon-checked-icon-other": state == STATES.Other,
            "ui-svg-checkbox__icon-circle": state == STATES.UnChecked,
            "ui-svg-checkbox__icon-checked-icon--disabled": disabled})}
          />

          {!disabled && !checked ?
            <svg className="employees-checkbox-circle" height="30" width="30">
              {innerStyle === 'red' ?
                <circle cx="15" cy="15" r="12.5" stroke="#979797" strokeWidth="3" fill="#ff0000"/>
                : null}
              <circle cx="15" cy="15" r="7" fill="white"/>
            </svg> : null}

        </div>
        {_text}

      </div>
    );
  } else if (type === 'small') {
    return (
      <div className="ui-svg-checkbox ui-svg-checkbox--small"
           onClick={(e) => !disabled && onChecked(state, e)}>
        <div className="ui-svg-checkbox__icon">
          <svg className="ui-svg-checkbox__icon-circle" height="30" width="30">
            <circle cx="15" cy="15" r="10" stroke="#979797" strokeWidth="3" fill="#ffffff"/>
            {!checked && !disabled ? <circle cx="15" cy="15" r="5" fill="#ff0000"/> : null}
            {disabled ? <circle cx="15" cy="15" r="5" fill="#c6c6c6"/> : null}
          </svg>

          <div className={classNames({
            "ui-svg-checkbox__icon-checked-icon": state == STATES.Checked,
            "ui-svg-checkbox__icon-checked-icon-other": state == STATES.Other,
            "ui-svg-checkbox__icon-circle": state == STATES.UnChecked,
            "ui-svg-checkbox__icon-checked-icon--disabled": disabled})}
          />

        </div>

        <div className="ui-svg-checkbox__text">{text}</div>
      </div>
    )
  } else if (type === 'tiny') {
    return (
      <div className={classNames('ui-svg-checkbox ui-svg-checkbox--tiny', {'ui-svg-checkbox--disabled': disabled})}
           onClick={(e) => !disabled && onChecked(state, e)}>
        <div className={classNames("ui-svg-checkbox__icon", {'ui-svg-checkbox__icon--disabled': disabled})}>
          <svg className="ui-svg-checkbox__icon-circle" height="24" width="24">
            <circle cx="12" cy="12" r="10" stroke="#979797" strokeWidth="2" fill="#ffffff"></circle>
          </svg>
          <div className={classNames({
            "ui-svg-checkbox__icon-checked-icon": state == STATES.Checked,
            "ui-svg-checkbox__icon-checked-icon-other": state == STATES.Other,
            "ui-svg-checkbox__icon-circle": state == STATES.UnChecked,
            "ui-svg-checkbox__icon-checked-icon--disabled": disabled})}
          />
        </div>
        <div className="ui-svg-checkbox__text">{text}</div>
      </div>
    )
  }
};
